export const AUDITOR = 'AUDITOR';
export const STATUS_FILTER = {
  onHold: 'ON HOLD',
  awaitingAudit: 'AWAITING AUDIT',
  inProgress: 'IN PROGRESS',
  inReview: 'IN REVIEW',
  awaitingReview: 'AWAITING REVIEW',
  archived: 'ARCHIVED',
  awaitingAssignment: 'AWAITING ASSIGNMENT',
  clientRebuttal: 'CLIENT REBUTTAL',
  rebuttalInProgress: 'REBUTTAL IN PROGRESS',
};
export const SELF = 'self';
export const ALL = ['AWAITING AUDIT', 'IN PROGRESS', 'CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'];
export const NEW_UPLOAD = ['AWAITING AUDIT'];
export const ARCHIVED = 'ARCHIVED';
export const REBBUTTAL = ['CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'];
export const URGENT = ['IN PROGRESS', 'AWAITING AUDIT', 'REBUTTAL IN PROGRESS'];

export const getAuditStatus = props => {
  switch (props) {
    case 'ON HOLD':
      return 'On Hold';
    case 'AWAITING AUDIT':
      return 'Awaiting Audit';
    case 'IN PROGRESS':
      return 'In Progress';
    case 'IN REVIEW':
      return 'In Progress';
    case 'AWAITING REVIEW':
      return 'Awaiting Review';
    case 'ARCHIVED':
      return 'Archived';
    case 'AWAITING ASSIGNMENT':
      return 'Awaiting Assignment';
    case 'CLIENT REBUTTAL':
      return 'Client Rebuttal';
    case 'REBUTTAL IN PROGRESS':
      return 'Rebuttal In Progress';
    default:
      return 'n/a';
  }
};
export const SIZE = 10;
export const AWAITING_AUDIT = 'AWAITING AUDIT';
export const MY_AUDITS_ORDERING = [
  'chart_id',
  'upload_date',
  'client',
  'specialty__name',
  'total_pages',
  'status',
  'updated_date',
  'auditor',
  'qa',
  'audited_date',
  '-chart_id',
  '-upload_date',
  '-client',
  '-specialty__name',
  '-total_pages',
  '-status',
  '-updated_date',
  '-auditor',
  '-qa',
  '-audited_date',
];
export const REQUIRED_FIELDS = [
  'encounter_no',
  'rendering',
  'enc_dt',

  'srvcs_no',
  // 'billed_cpt',
  'provider_rvu',
  'provider_dollar_value',

  // 'response',
  'agree',
  'disagree',
  
  'audited_cpt',

  'audited_rvu',
  'audited_dollar_value',
  'response',
];
export const ROLES_VALUES = {
  QA: 'QA',
  AUDITOR: 'Auditor',
  MANAGER: 'Manager',
  CLIENT: 'Client',
};

//  new
export const defaultColumns = [
  'provider_education',
  'number_complexity',
  'amount_complexity',
  'risk_complications',
];

export const addionalAttributesKeys = [
  'srvcs_no_',

  'icd_agree',
  'icd_disagree',

  'billed_cpt',
  'billed_cpt_',

  'billed_modifier',
  'billed_modifier_',

  'audited_icd_',

  'audited_cpt',
  'audited_cpt_',

  'audited_modifier',
  'audited_modifier_',

  ...defaultColumns,
];

export const auditedRuvColumns = [
  'audited_rvu',
  'audited_dollar_value',
  'response',
];

export const defaultDataProps = ['file_name', 'chart_id', 'id', 'row_id'];

export const firstSetColumnKeyOrder = ['missing_info', 'file_name', 'encounter_no', 'rendering', 'enc_dt'];

export const rvuColumnsOrder = [
  'provider_rvu',
  'provider_dollar_value',
  'notes',
  'agree',
  'disagree',
  'icd_agree',
  'icd_disagree',
];


export const DYNAMIC_AUDIT_SHEET_KEY = [
  'missing_info',
  'encounter_no',
  'rendering',
  'enc_dt',

  'srvcs_no',
  'billed_modifier',

  'provider_rvu',
  'provider_dollar_value',
  'response',
  'agree',
  'disagree',

  // 'audited_icd',

  'audited_code',

  'audited_cpt',
  'audited_modifier',

  'audited_rvu',
  'audited_dollar_value',
  'notes',

  'row_id',
  'file_name',
  'chart_id',
  'id'
];

export const FILE_TYPE = {
  CLIENT: "CLIENT",
  AUDIT: "AUDIT",
  ADDITIONAL: "ADDITIONAL"
}

export const FILTER_OPTIONS = [
  'All',
  // 'New Uploads',
  'In Audit',
  'In QA',
  'Archived',
  'Rebuttals',
  'On Hold',
  'Audited',
  // 'Urgent'
];

export const FILTER_OPTIONS_TO_CHART_STATUS_MAP = {
  'ALL': null,
  'New Uploads': 'AWAITING AUDIT',
  'In Audit': ['AWAITING AUDIT', 'IN PROGRESS', 'REBUTTAL IN PROGRESS'],
  'Audited': ['AWAITING REVIEW', 'IN REVIEW', 'ARCHIVED', 'CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'],
  'In QA': ['AWAITING REVIEW', 'IN REVIEW', 'CLIENT REBUTTAL'],
  'Archived': 'ARCHIVED',
  'Rebuttals': ['CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'],
  'On Hold': "ON HOLD",
  "Urgent": 'URGENT'
}  

export const ChartFilterInfo = [
  {
    name: "All",
    definition: "All the batches that have been assigned to you.",
  },
  {
    name: "In Audit",
    definition: "Batches which are currently being audited.",
  },
  {
    name:'In QA',
    definition: 'Batches which have been submitted by auditor and is in qa.'
  },
  {
    name:'Archived',
    definition: 'Batches which have been completed.'
  },
  {
    name: 'Rebuttal',
    definition: "Batches which are currently in rebuttal"
  },
  {
    name: 'On Hold',
    definition: 'Batches which are on hold'
  },
  {
    name: "Audited",
    definition: 'Batches which has already been audited by the auditor in the past. Could be at any stage post audit. '
  }
];